import { render, staticRenderFns } from "./ThemePreviewsPanel.vue?vue&type=template&id=ba4f1176&scoped=true"
import script from "./ThemePreviewsPanel.vue?vue&type=script&lang=js"
export * from "./ThemePreviewsPanel.vue?vue&type=script&lang=js"
import style0 from "./ThemePreviewsPanel.vue?vue&type=style&index=0&id=ba4f1176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4f1176",
  null
  
)

export default component.exports